export * from './login.component';


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/auth/login/index.ts